import { Input, InputElement } from "../../../../common/components";
import { GetInputOptions } from "../getInput";
import React from "react";
import getTranslatedValue from "../../../../utils/CustomerTranslations/getTranslatedValue";
export const getTermsInput = ({
  error,
  onChange,
  question,
  value,
  tCustomer
}: GetInputOptions) => {
  const {
    name,
    url,
    required
  } = question;
  const id = question.id ?? name;
  const label = getTranslatedValue(`customQuestion.${id}`, "name", tCustomer, question);

  // Shouldn't be possible, but just in case of bad data and mostly for TS
  if (typeof value === "string") throw new Error(`Type mismatch on value of question ${id}. Expected boolean, received string.`);
  if (!url) throw new Error(`Url missing on terms-type question ${id}`);
  const onCheck = (event: React.ChangeEvent<InputElement>) => {
    onChange({
      id,
      newValue: !!event.target.value !== value
    });
  };
  return <Input variant="terms" url={url} label={label} error={error} checked={value ?? false} onChange={onCheck} required={required} data-sentry-element="Input" data-sentry-component="getTermsInput" data-sentry-source-file="getTermsInput.tsx" />;
};